import request from '@/utils/request'
const Qs = require('qs')

// 获取所有
export function all(data) {
  return request({
    url: '/rumpson-extension/rest/lawyerNew/all',
    method: 'post',
    data: Qs.stringify(data)
  })
}

// 获取实例
export function page(data) {
  return request({
    url: '/rumpson-extension/rest/lawyerNew/page',
    method: 'post',
    data: Qs.stringify(data)
  })
}

// 保存
export function save(data) {
  return request({
    url: '/rumpson-extension/rest/lawyerNew/save',
    method: 'post',
    data: Qs.stringify(data)
  })
}

// 删除
export function del(data) {
  return request({
    url: '/rumpson-extension/rest/lawyerNew/delete',
    method: 'post',
    data: Qs.stringify(data)
  })
}
